import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TAB_NAMES } from "src/apps/common/menu-navigation/menuNavigation";
import TabHeader from "src/apps/common/tab-header/TabHeader";
import ReactTable from "src/components/tables/react-table/ReactTable";
import {
  calculateTotalAmount,
  getFormattedDate,
  handleCsvExport,
} from "src/helpers/helpers";
import useDebounce from "src/hooks/useDebounce";
import useManualRefresh from "src/hooks/useManualRefresh";
import useSetActiveTab from "src/hooks/useSetActiveTab";
import { getActiveApp } from "src/redux/selectors/app";
import { useGetPurchaseOrders } from "../api-purchase-orders";
import { PurchaseOrderType } from "./purchase-order-types";
import usePurchaseOrderTableColumns from "./usePurchaseOrderTableColumns";

const PurchaseOrderList = () => {
  useSetActiveTab(TAB_NAMES.PURCHASE_ORDER);
  const navigate = useNavigate();
  const [length, setLength] = useState(10);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText);
  const activeApp = useSelector(getActiveApp);
  const {
    isLoading,
    error,
    data,
    mutate: updatePurchaseOrderData,
    isValidating,
  } = useGetPurchaseOrders({ length, page, search: debouncedSearch });
  const { isRefreshing, handleRefresh } = useManualRefresh(
    updatePurchaseOrderData
  );

  const purchaseOrderData = useMemo(() => data?.data?.rows ?? [], [data?.data]);

  const mappedPurchaseOrderData = useMemo(
    () =>
      purchaseOrderData.map((item: PurchaseOrderType) => ({
        ...item,
        dateIssued: getFormattedDate(item.issueDate),
        totalPrice: calculateTotalAmount(item.tax + item.gst, item.totalPrice),
      })),
    [purchaseOrderData]
  );

  const totalRecords = useMemo(() => data?.data?.count, [data?.data?.count]);

  const columns = usePurchaseOrderTableColumns();

  return (
    <>
      <div className="flex flex-col gap-5">
        <TabHeader
          label="Purchase Orders"
          onRefresh={() => handleRefresh()}
          exportButton={{
            label: "Export",
            onClick: () => handleCsvExport(purchaseOrderData),
          }}
          printButton={{
            label: "Print",
            onClick: () => window.print(),
          }}
          // {...(activeApp === "STORE" && {
          //   createButton: {
          //     label: "Create Purchase Order",
          //     onClick: () => navigate("create"),
          //   },
          // })}
          search={{
            onChange: (val) => setSearchText(val),
            value: searchText,
          }}
        />

        <ReactTable
          columns={columns}
          data={mappedPurchaseOrderData}
          isLoading={isLoading || isRefreshing}
          pagination={{
            setLength,
            length,
            total: totalRecords,
            page,
            setPage,
          }}
        />
      </div>
    </>
  );
};

export default PurchaseOrderList;
